import type { CoordinatesProps } from "./Coordinates.type";
import type { MapCoordinates } from "@/modules/map";
import type { Coordinate } from "@/types";

import { Input } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import {
  MapInteractive,
  parseLatLngString,
  createMapMarker,
} from "@/modules/map";

const Coordinates = ({
  mapId,
  onCoordinateChange,
  onClear,
  value,
  disabled,
  loading = false,
  sizes = { ratio: "16:9" },
  ...rest
}: CoordinatesProps) => {
  const { t } = useTranslation();

  const [centerOnMarkersChange, setCenterOnMarkersChange] = useState(false);
  const [coordinate, setCoordinate] = useState<Coordinate | undefined>(value);
  const mapCoordinates = parseLatLngString({ coordinate: coordinate ?? "" });
  const currentMarker = createMapMarker({
    key: mapId,
    position: mapCoordinates,
  });

  const onMapClick = ({ lat, lng }: MapCoordinates) => {
    if (disabled) return;

    setCoordinate(`${lat},${lng}`);
    onCoordinateChange?.(lat, lng);
  };

  const onCenterMap = () => {
    if (centerOnMarkersChange) setCenterOnMarkersChange(false);
  };

  const updateCoordinates = (value: Coordinate) => {
    setCenterOnMarkersChange(true);
    setCoordinate(value);

    const parsedCoordinates = parseLatLngString({ coordinate: value });
    if (parsedCoordinates) {
      onCoordinateChange?.(parsedCoordinates.lat, parsedCoordinates.lng);
    } else {
      onClear?.();
    }
  };

  return (
    <>
      <Input
        {...rest}
        disabled={disabled}
        value={coordinate}
        onChange={(e) => updateCoordinates(e.target.value as Coordinate)}
        placeholder={t("global:coordinate.placeholder")}
        data-testid="coordinate"
      />
      <MapInteractive
        id={mapId}
        loading={loading}
        markers={currentMarker ? [currentMarker] : []}
        sizes={sizes}
        onMapClick={onMapClick}
        noInfoWindow
        centerOnMarkersChange={centerOnMarkersChange}
        onCenterMap={onCenterMap}
      />
    </>
  );
};

export default Coordinates;
